export default function LeftPointCard() {
    return (
        <div className="MuiPaper-root styles_headingLeft__uyNha MuiPaper-elevation1 MuiPaper-rounded">
            <p className="MuiTypography-root MuiTypography-body1">Điểm tích lũy</p>

            <div className="MuiGrid-root styles_wrapInfoPoint__arh7K MuiGrid-item">
                <p className="MuiTypography-root styles_currPoint__M2LUK MuiTypography-body1">
                    <span>10</span>{" "}
                    <span style={{ fontSize: "16px" }}>điểm</span>
                </p>
            </div>

            <div
                className="styles_wrapBtnGotoExchange__xB0u_"
                style={{ marginTop: "16px" }}
            >
                <button
                    className="MuiButtonBase-root MuiButton-root MuiButton-text jss8"
                    tabIndex={0}
                    type="button"
                >
                    <span className="MuiButton-label">Đổi điểm ngay</span>
                    <span className="MuiTouchRipple-root"></span>
                </button>
            </div>

            <div
                className="MuiGrid-root styles_loyaltyLinkWrapper__6CPgF MuiGrid-item"
                style={{ marginTop: "16px" }}
            >
                <a
                    className="styles_mobile_rootBase__8z7PQ"
                    target="_blank"
                    rel="noreferrer"
                    href="#"
                >
                    <span className="styles_loyaltyLink__9cX_u">
                        Chính sách về điểm tích luỹ
                    </span>
                </a>
            </div>
        </div>
    );
}
